import Uploader from './components/uploader';
import Dialog from './components/dialog';
import Loading from './components/loading';
import Org from './components/org';

const components = [
  Uploader,
  Dialog,
  Loading,
];

const install = function (Vue) {

  if (install.installed) return;
  install.installed = true;

  components.forEach(component => {
    Vue.component(component.name, component);
  });

  Vue.prototype.$W2Org = Org;

}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// 手动赋值版本号
const versionTime = '@2022.12.26';


export default {
  version: versionTime,
  install,
  Uploader,
  Dialog,
  Loading,
  //Org,

}
